import React from 'react'
import UserPage from '../../common/UserPage/UserPage'
import Footer from '../../common/Footer/Footer'
import TherapistSupport from '../../components/TherapistSupport/TherapistSupport'
import { useSelector } from 'react-redux'

function TherapistSupportPage() {
    const therapistState = useSelector((state) => state.therapist) || {};
  const { therapist} = therapistState;
  return (
    <div>
        <UserPage customImage={therapist?.picture} />
        <TherapistSupport />
        <Footer />
    </div>
  )
}

export default TherapistSupportPage